/**
 * Isotipo "kora" — mismo trazo SVG que `KoraLogo.tsx` de la v1, no un texto
 * en mayúsculas: la "o" central lleva el acento lima de marca.
 */
export function KoraLogo({ variant = 'light' }: { variant?: 'light' | 'dark' }) {
  const fill = variant === 'dark' ? '#122235' : '#F9FCFF';
  return (
    <svg viewBox="0 0 142 72" fill="none" xmlns="http://www.w3.org/2000/svg" width="120" height="61" role="img" aria-label="Kora">
      <path d="M16 41.7843C22.1764 41.7843 25.3268 43.5673 25.3268 53.8536V54.9508H16V41.7843Z" fill={fill} />
      <path d="M25.3268 28.0693C25.3268 38.3556 22.1764 40.1385 16 40.1385V16H25.3268V28.0693Z" fill={fill} />
      <path d="M37.1267 35.8869C34.5207 38.4927 30.2414 40.1385 24.0966 40.1385L34.795 27.2464H45.7677L37.1267 35.8869Z" fill={fill} />
      <path d="M24.0281 41.7852C30.6531 41.7852 34.6557 43.4661 37.2781 46.1274L45.9735 54.9516H34.7937L24.0281 41.7852Z" fill="#BBFD53" />
      <path
        d="M46.8571 32.258C47.3321 34.5393 49.2509 40.2141 53.1265 44.6627C57.0021 49.1112 63.6704 51.7443 66.5201 52.5047C65.5227 54.0731 61.8181 55.4989 58.256 55.4989C47.7121 55.4989 43.4375 46.2311 43.4375 40.9555C43.4375 36.7351 45.7173 33.3986 46.8571 32.258Z"
        fill={fill}
      />
      <path
        d="M57.971 26.6973C68.5149 26.6973 72.7894 35.9651 72.7894 41.2407C72.7894 45.4611 70.5097 48.7976 69.3698 49.9382C68.8949 47.6569 66.976 41.9821 63.1005 37.5335C59.2249 33.085 52.5566 30.4519 49.7068 29.6915C50.7042 28.1231 54.4089 26.6973 57.971 26.6973Z"
        fill={fill}
      />
      <path
        d="M87.5982 27.248C91.6121 27.248 93.4413 28.765 94.2166 30.5073C94.5455 31.1796 94.7304 31.9352 94.7304 32.7341C94.7304 32.7925 94.7289 32.8507 94.7269 32.9087C94.7293 32.9885 94.7304 33.0675 94.7304 33.1455C94.7304 35.0903 93.5812 36.3645 92.2731 37.0819C91.5088 37.543 90.6133 37.8087 89.6556 37.8087C89.6042 37.8087 89.553 37.8075 89.5021 37.806C88.4098 37.78 87.6039 37.4766 86.9553 37.031C86.2789 36.6051 85.7103 36.0241 85.2992 35.3378C84.3397 34.1042 83.4823 32.8713 81.5632 32.8712C79.9174 32.8712 78.82 34.2427 78.82 35.4771C78.82 38.9927 84.4189 38.6424 84.5769 41.786H84.5807V54.9525H75.2539V37.3972C75.3911 34.0142 78.0519 27.248 87.5982 27.248Z"
        fill={fill}
      />
      <path
        d="M106.013 45.2135C108.544 44.509 115.241 43.7283 115.166 44.6849C114.605 51.9322 110.268 55.9974 105.208 55.6056C102.339 55.3833 100.218 53.0161 100.44 50.1463C100.663 47.2767 102.92 46.0743 106.013 45.2135Z"
        fill={fill}
      />
      <path
        d="M109.264 27.248C114.613 27.248 126.002 29.1682 126.002 41.786V54.9525H116.675V34.7913C116.675 32.668 115.905 30.5448 113.618 30.4095C111.752 30.5575 108.514 32.5284 104.601 36.7115C100.688 40.8945 98.8217 46.792 98.0902 49.535C96.5814 48.575 95.2098 45.0091 95.2098 41.5803C95.2098 32.365 102.613 28.0684 107.774 27.3557C108.177 27.2869 108.671 27.2481 109.264 27.248Z"
        fill={fill}
      />
    </svg>
  );
}
